export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/icons/info_icon-448719ed3ff10aa3b38154252c8d5457.svg";